import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const METADATA_FIELDS_WITH_DATA_QUERY_KEY = 'folders.metadataFieldsWithData';

export const useGetMetadataFieldsWithData = ({
  folderId,
  enabled = true,
}: {
  folderId?: string;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [METADATA_FIELDS_WITH_DATA_QUERY_KEY, { folderId, tenantId }],
    queryFn: () => {
      return folderId
        ? api.tenants.getFolderMetadataFieldsWithData(tenantId, folderId)
        : api.tenants.getRootMetadataFieldsWithData(tenantId);
    },
    enabled: enabled && !!tenantId,
  });

  return {
    metadataFieldNames: data?.data?.metadataFieldNames ?? [],
    isLoading,
    error,
  };
};
